<template>
  <div>
    <files-upload-input
      :id="`files-uploader-${$attrs.label}`"
      :label="$attrs.label"
      :accept="$attrs.accept"
      :rules="$attrs.rules"
      :cropper="$attrs.cropper"
      :stencil-props="$attrs['stencil-props']"
      :multiple="$attrs.multiple"
      @update:files="startUploadFiles"
    />
  </div>
</template>

<script>
import handleAlerts from '@/compositions/common/handleAlerts'
import FilesAPI from '@/compositions/Files/FilesAPI'
import FilesUploadInput from './FilesUploadInput.vue'

export default {
  name: 'FilesUploader',
  components: { FilesUploadInput },
  data() {
    return {
      files: [],
    }
  },
  setup() {
    const { successfulOperationAlert } = handleAlerts()
    const { filesURL, uploadFiles } = FilesAPI()

    return {
      filesURL,
      uploadFiles,
      successfulOperationAlert,
    }
  },
  methods: {
    startUploadFiles(files) {
      this.formatBinaryFiles(files)
      if (this.files.length) {
        this.uploadBinaryFiles().then(() => {
          this.$emit('update:files', this.files)
        })
      }
    },
    formatBinaryFiles(files) {
      this.files = files.map(file => ({ url: file }))
    },
    uploadBinaryFiles() {
      return this.uploadFiles(this.files, this.$attrs['file-type']).then(res => {
        const uploadedFiles = res.data.data
        this.setBinaryFilesId(uploadedFiles)
      })
    },
    setBinaryFilesId(uploadedFiles) {
      uploadedFiles.forEach((file, index) => {
        this.$set(this.files[index], 'id', file.id)
      })
    },
  },
}
</script>

<style>

</style>
